// eslint-disable-next-line prefer-import/prefer-import-over-require
const exports = require('./index');

module.exports = exports;
